import {
  useCallback, useState, useMemo, useEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { parseFloatData, objectFilter } from '../../../../../../shared/utils/commonUtils';
import { updatePaymentsInfoUsedForPay, deletePaymentsInfoUsedForPay, selectTotalInputAmount } from '../paymentMethodsSlice';

export default function useCrurrencyInput({
  paymentAccountId, paymentMethodType, isPrefillValue, onChange,
}) {
  const dispatch = useDispatch();
  const totalInputAmount = useSelector(selectTotalInputAmount);
  const {
    entities: {
      envParams: {
        currencyCode,
      },
    },
    refundTotalAmount,
  } = useSelector(state => state.mainStateData);

  const [ showPlaceholder, setShowPlaceholder ] = useState(false);
  const placeholder = useMemo(() => {
    const placeholderAmount = totalInputAmount <= refundTotalAmount
      ? parseFloatData(refundTotalAmount - totalInputAmount)
      : '';
    return showPlaceholder ? placeholderAmount : '';
  }, [ totalInputAmount, refundTotalAmount, showPlaceholder ]);

  const handleFocus = useCallback(() => {
    setShowPlaceholder(true);
  }, []);

  const handleBlur = useCallback(() => {
    setShowPlaceholder(false);
  }, []);

  const handleChange = useCallback((value) => {
    if (value === '') {
      dispatch(deletePaymentsInfoUsedForPay(objectFilter({
        paymentMethodType,
        paymentAccountId,
      })));
    } else {
      dispatch(updatePaymentsInfoUsedForPay(objectFilter({
        paymentInfoObj: {
          amount: Number(value), paymentMethodType, paymentAccountId,
        },
        findPaymentConfig: {
          paymentMethodType, paymentAccountId,
        },
      })));
    }
    onChange?.(value);
  }, [ dispatch, paymentAccountId, paymentMethodType, onChange ]);

  useEffect(() => {
    // To avoid situations where ''>=0 equals true
    if (isPrefillValue && (refundTotalAmount === 0 || refundTotalAmount > 0)) {
      dispatch(updatePaymentsInfoUsedForPay(objectFilter({
        paymentInfoObj: {
          amount: Number(refundTotalAmount),
          paymentMethodType,
          paymentAccountId,
        },
        findPaymentConfig: {
          paymentMethodType,
          paymentAccountId,
        },
      })));
    }
  }, [ refundTotalAmount, isPrefillValue, dispatch, paymentMethodType, paymentAccountId ]);

  return {
    currencyCode,
    placeholder,
    handleFocus,
    handleBlur,
    handleChange,
  };
}
